<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Price Lists</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>

      <v-card-text>
        <v-row class="mt-1">
          <!-- <v-col cols="12" md="6">
            <v-btn color="accent" small to="/new-price-list">
              <v-icon left dark>mdi-plus</v-icon>New Price List
            </v-btn>
          </v-col> -->

          <!-- <v-col cols="12" md="6">
            <v-btn class="float-right" color="primary" small text to="/copy-price-list">
              <v-icon left dark></v-icon>Copy Price List
            </v-btn>
          </v-col> -->

        </v-row>

        <v-row>
          <v-text-field name="priceListSearch" v-model="search" append-icon="mdi-magnify" label="Search" single-line
            hide-details></v-text-field>
        </v-row>

        <v-row>
          <v-col cols="12" sm="12" md="12">
            <!-- start of table -->
            <v-data-table :items-per-page="pageItems" :headers="headers" :items="priceLists" :search="search">
              <!-- show template -->
              <template v-slot:item.showOnProductEdit="{ item }">{{ item.showOnProductEdit == true ? "Yes" : "No"
                }}</template>
              <!-- end -->

              <!-- action template -->
              <template v-slot:item.action="{ item }">
                <v-btn color="editIcon" text :to="`/price-lists/${item.id}`" icon>
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <!-- end -->

              <!-- action template -->
              <template v-slot:item.viewAction="{ item }">
                <v-btn color="accent" text :to="`/price-lists/manage/${item.id}`">
                  <v-icon left>mdi-eye</v-icon> Manage Prices
                </v-btn>
              </template>
              <!-- end -->


              <!-- excel template -->
              <template v-slot:item.importSellingPrices="{ item }">
                <v-btn color="green" text :to="`/price-lists/import/${item.id}`">
                  <v-icon left>mdi-file-excel</v-icon> Import Selling Prices
                </v-btn>
              </template>
              <!-- end -->

               <!-- excel template -->
              <template v-slot:item.importBuyingPrices="{ item }">
                <v-btn color="primary" text :to="`/import-buying-prices/${item.id}`">
                  <v-icon left>mdi-file-excel</v-icon> Import Buying Prices
                </v-btn>
              </template>
              <!-- end -->

            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    search: "",
    pageItems: 100,
    headers: [
      { text: "Price List", value: "Name" },
      { text: "Import Selling Prices", value: "importSellingPrices" },
      { text: "Import Buying Prices", value: "importBuyingPrices" },
    ],
    priceLists: []
  }),
  methods: {
    getData() {
      const self = this;
      this.$store
        .dispatch("get", `/price-list`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.priceLists = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    }
  },
  created() {
    this.getData();
  }
};
</script>